import { ThemeProvider } from '@/components/ui/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import RoutesComponent from '@/view/shared/routes/RoutesComponent';
import { Loader2 } from 'lucide-react';
import { Suspense, useEffect, useState } from 'react';
import {
  Provider,
  useDispatch,
  useSelector,
} from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import authActions from './modules/auth/authActions';
import selectors from './modules/auth/authSelectors';
import { AuthToken } from './modules/auth/authToken';
import settingsActions from './modules/settings/settingsActions';
import {
  configureStore,
  reduxHistory,
} from './modules/store';
import routes from './view/routes';

const store = configureStore();

// TODO: Add a loading screen
function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

function AppContent() {
  const dispatch = useDispatch();
  const [isInitializing, setIsInitializing] =
    useState(true);
  const loading = useSelector(selectors.selectLoading);
  const [searchParams] = useSearchParams();
  const pdf = searchParams.get('pdf');

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Apply token from URL if exists
        AuthToken.applyFromLocationUrlIfExists();

        // Initialize auth
        await dispatch(authActions.doInit());
        await dispatch(settingsActions.doInit());
      } finally {
        setIsInitializing(false);
      }
    };

    initializeApp();
  }, [dispatch]);

  if (isInitializing || loading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="ui-theme"
    >
      <Suspense fallback={<LoadingScreen />}>
        <RoutesComponent routes={routes as any} />
        {!pdf && <Toaster />}
      </Suspense>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <Router history={reduxHistory}>
        <AppContent />
      </Router>
    </Provider>
  );
}
